import { RealtimeInterface } from '../services/realtime/realtime-interface';
import { User } from './user.class';

export class PlanningFixed implements RealtimeInterface {
    public id: number;

    public fixeduntil: Date;

    public fixed_date: Date;

    public user_id: number;

    public created_at: Date;

    public user: User;
}
